import React from 'react'

const Index = () => {
  return (
    <div>Error</div>
  )
}

export default Index